import { finalSaleCalculate } from '../../utils/finalSale';
import { renderFinalSale } from '../../components/FinalSale';

const finalSale = () => {
  const productNodes = document.querySelectorAll('.pdp-c-atc-size-selector__size-item');

  finalSaleCalculate({
    isInternational: window.theme.country_iso !== 'US',
    productNodes,
  })
    .then((results) => {
      // Store and update after fetching data from Shopify
      window.finalSaleResults = results;
      // Turn off/on final sale label on PDP
      renderFinalSale(results);
    })
    .catch((err) => {
      console.error(`Error while trying to calculate final sale message on pdp: ${err}`);
    });
};

export default finalSale;
